import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getLatestHappeningsData} from '../../utils/endpoints'
import Loading from '../components/loading';

const LatestHappenings = (props) => {
    const [latestHappenings, setLatestHappenings] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const latestHappenings = await getLatestHappeningsData(id);
            setLatestHappenings(latestHappenings);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      
    </div>
  );
};

export default LatestHappenings;